import { z } from 'zod';
export const AssignmentCreatedStatusEnum = z.enum([
    'Note',
    'Carrier Desk Adjuster Assigned',
    'Carrier Desk Adjuster Removed',
    'Sender Desk Adjuster Assigned',
    'Sender Desk Adjuster Removed',
    'Attention Needed',
]);
export const AssignmentUpdatedStatusEnum = z.enum([
    'Reviewed',
    'Contacted',
    'Inspected',
    'Not Sold',
    'QA Rejected',
    'Rejected', // documentation for this status is unclear, careful if using it
    'QA Approved',
    'Client Approved',
    'Client Rejected',
    'Job Started',
    'Job Completed',
    'File Closed',
    'File Reopened',
    'Appointment Scheduled',
    'Appointment Cancelled',
    'Planned Inspection',
    'Site Inspected',
    // The following values duplicate ControlPointType.jobCompleted ('Job Completed'),
    // ControlPointType.jobNotSold ('Not Sold'), and ControlPointType.jobStarted ('Job Started'),
    // which are already listed above. They are kept as literals so zod v4 can infer this enum.
]);
export const XAStatusEnum = z.enum([
    ...AssignmentCreatedStatusEnum.options,
    ...AssignmentUpdatedStatusEnum.options,
]);
